import { MobileMenuController } from './controllers/MobileMenuController';
import { LazyLoadController } from './controllers/LazyLoadController';
import { LanguageController } from './controllers/LanguageController';
import { EmailController } from './controllers/EmailController';
import { ProductController } from './controllers/ProductController';
import { InstafeedController } from './controllers/InstafeedController';

// import Modernizr from 'modernizr';

window.addEventListener('load', () => {
  LazyLoadController();
  MobileMenuController();
  LanguageController();
  EmailController();
  ProductController();
  InstafeedController();
});



// WEBPACK FOOTER //
// ./src/js/app.js